// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5906":"45016303","5909":"45016303"}[chunkId] + ".chunk.css";
};